var map = {
	"./auth.js": 12661,
	"./beneficiaries.js": 35642,
	"./collectionpoints.js": 39652,
	"./config.js": 54933,
	"./crud.js": 93251,
	"./global.js": 16224,
	"./layout.js": 37581,
	"./notification.js": 40952,
	"./schoolperiod.js": 23778,
	"./staff.js": 69301,
	"./stats.js": 20068,
	"./todo.js": 98483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70634;